/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Template_TitleInputs */

const en__field_template_title = /** @type {(inputs: _Field_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const de__field_template_title = /** @type {(inputs: _Field_Template_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {_Field_Template_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_template_title = /** @type {((inputs?: _Field_Template_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Template_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_template_title(inputs)
	return de__field_template_title(inputs)
});